import { FILTER_PARAM } from "../Filters/filterUrl"

// Listing pages keep their active tab in the path. A route (Layout/routes.js) is
// { path, tabs: { tabId: slug } }: the tab whose slug is "" is served at `path`,
// every other tab one segment below it (/incidents/ and /incidents/assigned).

const trimSlashes = (path) => String(path || "").replace(/^\/+|\/+$/g, "")

// "" at the base path itself, the remainder below it, null outside it.
export function slugFromPath(basePath, pathname) {
    const base = trimSlashes(basePath)
    const path = trimSlashes(pathname)
    if (path === base) return ""
    if (!path.startsWith(`${base}/`)) return null
    return path.slice(base.length + 1)
}

// The tab a route settles on absent a slug: the tab served at the bare path (slug ""), or,
// for a section root with no page of its own (`redirectTo`, every tab slugged), whichever
// tab's own path is the redirect target. Undefined if neither applies.
export function defaultTabId(route) {
    const tabIds = Object.keys(route.tabs || {})
    const emptySlugTab = tabIds.find(tabId => route.tabs[tabId] === "")
    if (emptySlugTab !== undefined) return emptySlugTab
    if (!route.redirectTo) return undefined
    return tabIds.find(tabId => pathForTab(route, tabId) === route.redirectTo)
}

// The tab a pathname names; undefined for an unknown slug or a path outside the route.
export function tabIdForPath(route, pathname) {
    const slug = slugFromPath(route.path, pathname)
    if (slug === null) return undefined
    return Object.keys(route.tabs || {}).find(tabId => route.tabs[tabId] === slug)
}

export function pathForTab(route, tabId) {
    const slug = route.tabs?.[tabId]
    return slug ? `/${trimSlashes(route.path)}/${slug}` : route.path
}

// True when pathname is this route's own page: its base path (trailing slash tolerant)
// or one of its tabs. A prefix match would be wrong -- /cars/ would light up for every
// Cars page and /incidents/ for Claims/TPA, which sit one segment below a sibling route's
// own base path but are pages of their own.
export function isOnRoute(route, pathname) {
    return slugFromPath(route.path, pathname) === "" || tabIdForPath(route, pathname) !== undefined
}

// `?filter=` is one page-wide param and tabs usually list different things, so a tab
// switch drops it; landing on a page (replace, clearFilters: false) keeps a shared link's filters.
export function goToTab(navigate, location, route, tabId, { replace = false, clearFilters = true } = {}) {
    const params = new URLSearchParams(location.search)
    if (clearFilters) params.delete(FILTER_PARAM)
    navigate({ pathname: pathForTab(route, tabId), search: params.toString() }, { replace })
}
